var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.035,
    height: 16.021,
    viewBox: "0 0 16.035 16.021",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_51369",
    "data-name": "Group 51369",
    transform: "translate(0 0.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35350",
    "data-name": "Path 35350",
    d: "M15.935,3.748H14.382V3.056a.456.456,0,1,0-.911,0v2.38a.887.887,0,0,0-.456.776.911.911,0,1,0,1.367-.776V4.659h1.553a1.682,1.682,0,0,1,1.688,1.688v1.4H3.411v-1.4A1.693,1.693,0,0,1,5.1,4.659h.793V3.748H5.1a2.6,2.6,0,0,0-2.6,2.6V16a2.6,2.6,0,0,0,2.6,2.6H15.935a2.6,2.6,0,0,0,2.6-2.6V6.347a2.6,2.6,0,0,0-2.6-2.6ZM17.622,16a1.682,1.682,0,0,1-1.688,1.688H5.1A1.682,1.682,0,0,1,3.411,16V8.659H17.639V16Z",
    transform: "translate(-2.5 -2.6)",
    fill: "#f45e29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35351",
    "data-name": "Path 35351",
    d: "M19.78,51.059h.76a.98.98,0,0,0,0-1.959h-.76a.98.98,0,0,0-.98.98A.991.991,0,0,0,19.78,51.059Z",
    transform: "translate(-16.049 -41.253)",
    fill: "#f45e29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35352",
    "data-name": "Path 35352",
    d: "M42.98,51.059h.76a.98.98,0,0,0,0-1.959h-.76a.98.98,0,0,0,0,1.959Z",
    transform: "translate(-35.334 -41.253)",
    fill: "#f45e29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35353",
    "data-name": "Path 35353",
    d: "M66.18,51.059h.76a.98.98,0,0,0,0-1.959h-.76a.98.98,0,0,0,0,1.959Z",
    transform: "translate(-54.619 -41.253)",
    fill: "#f45e29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35354",
    "data-name": "Path 35354",
    d: "M19.78,71.559h.76a.98.98,0,0,0,0-1.959h-.76a.98.98,0,0,0-.98.98.991.991,0,0,0,.98.979Z",
    transform: "translate(-16.049 -58.293)",
    fill: "#f45e29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35355",
    "data-name": "Path 35355",
    d: "M42.98,71.559h.76a.98.98,0,0,0,0-1.959h-.76a.98.98,0,0,0,0,1.959Z",
    transform: "translate(-35.334 -58.293)",
    fill: "#f45e29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35356",
    "data-name": "Path 35356",
    d: "M66.18,71.559h.76a.98.98,0,0,0,0-1.959h-.76a.98.98,0,0,0,0,1.959Z",
    transform: "translate(-54.619 -58.293)",
    fill: "#f45e29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35357",
    "data-name": "Path 35357",
    d: "M25.312,7.109a.9.9,0,0,0,.456-1.689V4.644h5.168v-.9H25.768V3.056a.456.456,0,1,0-.912,0V5.437a.888.888,0,0,0-.456.777.9.9,0,0,0,.912.9Z",
    transform: "translate(-20.706 -2.6)",
    fill: "#f45e29"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalender);
export default __webpack_public_path__ + "static/media/icon_calender.37905969.svg";
export { ForwardRef as ReactComponent };